import { InjectionKey } from 'vue';
import { createContext, useContext } from '@mts-fe/hooks';
import type {
  SchemaActionContextProps,
  SchemaGlobalContextProps,
  SchemaPageContextProps,
} from '..';

const key: InjectionKey<SchemaPageContextProps> = Symbol('schema');
export function createSchemaPageContext(context: SchemaPageContextProps) {
  return createContext<SchemaPageContextProps>(context, key, { native: true });
}
export function useSchemaPageContext() {
  return useContext<SchemaPageContextProps>(key);
}

const actionKey: InjectionKey<SchemaPageContextProps> = Symbol('schema');
export function createSchemaActionContext(context: SchemaActionContextProps) {
  return createContext<SchemaActionContextProps>(context, actionKey, { native: true });
}
export function useSchemaActionContext() {
  return useContext<SchemaActionContextProps>(actionKey);
}

const globalKey: InjectionKey<SchemaPageContextProps> = Symbol('schema');
export function createSchemaGlobalContext(context: SchemaGlobalContextProps) {
  return createContext<SchemaGlobalContextProps>(context, globalKey, { native: true });
}
export function useSchemaGlobalContext() {
  return useContext<SchemaGlobalContextProps>(globalKey);
}
